import React, { useState } from 'react';
import axios from 'axios';
import { ArrowRightLeft, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/shop`;

// Inline "move to another job #" control for the Consumables-by-WO report: search a WO, click it → onMove(wo)
export function MoveToWOButton({ label, onMove, testid, compact = false }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [busy, setBusy] = useState(false);

  const search = async (v) => {
    setQ(v);
    if (v.trim().length < 2) { setResults([]); return; }
    try { const r = await axios.get(`${API}/work-orders`, { params: { q: v.trim() } }); setResults((r.data || []).slice(0, 6)); }
    catch { setResults([]); }
  };
  const pick = async (wo) => {
    setBusy(true);
    try { await onMove(wo); setOpen(false); setQ(''); setResults([]); }
    finally { setBusy(false); }
  };

  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} title={`Move ${label} to a different job #`} data-testid={testid}
        className={`inline-flex items-center gap-1 rounded border border-blue-300 text-blue-700 hover:bg-blue-50 ${compact ? 'px-1 py-0.5 text-[10px]' : 'px-2 py-0.5 text-[11px] font-semibold'}`}>
        <ArrowRightLeft className="w-3 h-3" />{compact ? '' : ` Move ${label}`}
      </button>
    );
  }
  return (
    <div className="relative inline-flex flex-col gap-1" data-testid={`${testid}-open`}>
      <div className="flex items-center gap-1">
        <input type="text" value={q} onChange={e => search(e.target.value)} placeholder="New WO#…" autoFocus
          onKeyDown={e => { if (e.key === 'Escape') { setOpen(false); setQ(''); setResults([]); } if (e.key === 'Enter' && results[0]) pick(results[0]); }}
          className="w-32 px-1.5 py-0.5 bg-white border border-blue-500 rounded text-xs outline-none" data-testid={`${testid}-search`} />
        {busy ? <Loader2 className="w-3 h-3 animate-spin text-blue-600" /> : (
          <button type="button" onClick={() => { setOpen(false); setQ(''); setResults([]); }} className="text-[10px] text-slate-500 hover:text-slate-800" data-testid={`${testid}-cancel`}>cancel</button>
        )}
      </div>
      {results.length > 0 && (
        <div className="absolute z-30 top-7 left-0 w-72 bg-white border border-slate-300 rounded shadow-lg max-h-44 overflow-y-auto text-left" data-testid={`${testid}-results`}>
          {results.map(wo => (
            <button key={wo.project_number} type="button" onClick={() => pick(wo)} disabled={busy} data-testid={`${testid}-pick-${wo.project_number}`}
              className="w-full text-left px-2 py-1.5 hover:bg-blue-50 text-xs border-b border-slate-100 disabled:opacity-50">
              <span className="font-mono text-blue-600 font-bold">{wo.project_number}</span> — {wo.client_name}{wo.title ? <span className="text-slate-500"> · {wo.title}</span> : ''}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
